/* ============================================================
   lp-perluna.js — Landing Befem · JS global del layout theme.landing
   Adaptado de script1.js (BUNDLE ENGINE v3): sin pixels, sin widget COD externo, sin /cart/add.js.
   PRODUCT / OFFER llegan desde Liquid (window.LP_PRODUCT / window.LP_OFFER, seccion lp-buy).
   La compra pasa por el boton de Releasit dentro de #lpReleasitHost (window.lpOpenReleasit).
   ============================================================ */
(function(){
if(window.__lpLandingBooted) return; window.__lpLandingBooted=1;
function lpBoot(){
/* ============ BUNDLE ENGINE v3 — modo Releasit (sin bundle propio en el DOM) ============ */
var PRODUCT = (window.LP_PRODUCT && typeof window.LP_PRODUCT==="object") ? window.LP_PRODUCT : {};
(function(){
  var d={name:"", rawPrice:0, comparePrice:0, cur:"S/", currency_iso:"PEN", handle:"", discount_display:"amount",
         colors:[], sizes:[], thumb:"", atc:"A\u00f1adir al carrito", save_word:"Ahorra", variant_map:{}, color_images:{},
         discount_codes:{}, lbl_color:"Color", lbl_size:"Talla", cart_err:"No se pudo a\u00f1adir al carrito \u2014 reintenta",
         locale:"es-PE", cod:true};
  for(var k in d){ if(PRODUCT[k]==null) PRODUCT[k]=d[k]; }
  PRODUCT.rawPrice=+PRODUCT.rawPrice||0; PRODUCT.comparePrice=+PRODUCT.comparePrice||0;
  if(!PRODUCT.colors) PRODUCT.colors=[]; if(!PRODUCT.sizes) PRODUCT.sizes=[];
})();
var OFFER = (window.LP_OFFER && typeof window.LP_OFFER==="object") ? window.LP_OFFER : {use_compare_price:true, quantities:[]};
if(!OFFER.quantities || typeof OFFER.quantities.map!=="function") OFFER.quantities=[];
if(OFFER.use_compare_price==null) OFFER.use_compare_price=true;
window.LP_PRODUCT=PRODUCT; window.LP_OFFER=OFFER;
// formato de precio: "S/ 89.00" (es-PE). Override: PRODUCT.dec_sep / PRODUCT.cur_sep
var DEC_SEP = (PRODUCT.dec_sep!=null) ? String(PRODUCT.dec_sep) : ".";
var CUR_SEP = (PRODUCT.cur_sep!=null) ? String(PRODUCT.cur_sep) : " ";
var selectedIdx = 0;
var st = { units: [] };
function ensureUnits(qty){
  while(st.units.length < qty) st.units.push({color:(PRODUCT.colors&&PRODUCT.colors[0])||"", size:(PRODUCT.sizes&&PRODUCT.sizes[0])||"", cf:{}});
  st.units.length = qty;
}

function money(v){ return PRODUCT.cur + CUR_SEP + (+v||0).toFixed(2).replace(".", DEC_SEP); }
/* escape per i valori che finiscono in innerHTML (nomi variante/etichette possono venire da pagine
   scrapate: senza escape un valore con markup diventava XSS persistente sulla landing) */
function esc(s){ return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }
function calc(row){
  var base = PRODUCT.rawPrice * row.quantity;
  var final = base;
  if(row.discount_type==="percentage") final = base*(1-row.discount_value/100);
  else if(row.discount_type==="fixed") final = Math.max(0, base - row.discount_value);
  var orig = (OFFER.use_compare_price ? PRODUCT.comparePrice : PRODUCT.rawPrice) * row.quantity;
  var save = Math.max(0, orig - final);
  var pct = orig>0 ? Math.round((1 - final/orig)*100) : 0;
  return { base:base, final:final, orig:orig, save:save, pct:pct };
}
function optSelect(kind, u){
  var vals = kind==="color" ? PRODUCT.colors : PRODUCT.sizes;
  if(!vals || !vals.length) return "";
  var cur = st.units[u][kind];
  var lbl = kind==="color" ? (PRODUCT.lbl_color||"") : (PRODUCT.lbl_size||"");
  var opts = vals.map(function(v){ return '<option value="'+esc(v)+'"'+(v===cur?' selected':'')+'>'+esc(v)+'</option>'; }).join("");
  return '<span class="sel"><label>'+esc(lbl)+'</label><select data-u="'+u+'" data-k="'+kind+'" onchange="onOpt(this)" onclick="event.stopPropagation()">'+opts+'</select></span>';
}
// immagine per un colore (dalla mappa color_images del server o dal live-sync varianti; fallback thumb)
function colorImg(color){ var m=PRODUCT.color_images||{}; return (color&&m[color]) || PRODUCT.thumb || ""; }
// campi PERSONALIZZAZIONE per unità (v61: es. targa incisa — data, nome, nome #2).
// PRODUCT.custom_fields = [{label:"Entrez la date", key:"date", required:true}, ...]
// I valori finiscono nell'ordine Shopify come line item properties (visibili nel dettaglio).
function cfSet(u, k, v){ ensureUnits(u+1); st.units[u].cf = st.units[u].cf || {}; st.units[u].cf[k] = v; }
// stili iniettati dal JS (v61a): autocontenuti → i ritocchi arrivano alle pagine esistenti col solo upgrade-js
function cfStyles(){
  if(document.getElementById("cfStyles")) return;
  var s=document.createElement("style"); s.id="cfStyles";
  s.textContent=".cfields{width:100%;margin-top:10px;padding:13px 14px;background:#faf9f7;border:1px solid #e8e5df;border-radius:12px;display:flex;flex-direction:column;gap:11px;box-sizing:border-box}"
    +".cfields-t{font-size:11.5px;font-weight:800;letter-spacing:.05em;text-transform:uppercase;color:#8a867d;display:flex;align-items:center;gap:6px;margin-bottom:1px}"
    +".cfield-w{display:flex;flex-direction:column;gap:5px}"
    +".cfield-l{font-size:12.5px;font-weight:700;color:#3b3833}"
    +".cfield-l b{color:#c0392b;font-weight:800}"
    +".cfield{width:100%;padding:11px 13px;border:1.5px solid #ddd8d0;border-radius:9px;font:inherit;font-size:14px;background:#fff;color:#16161a;box-sizing:border-box;transition:border-color .15s,box-shadow .15s}"
    +".cfield:focus{outline:none;border-color:#16161a;box-shadow:0 0 0 3px rgba(22,22,26,.07)}"
    +".cfield::placeholder{color:#b9b4aa}";
  document.head.appendChild(s);
}
function cfInputs(u){
  var cf = PRODUCT.custom_fields || [];
  if(!cf.length) return "";
  cfStyles();
  var h = '<div class="cfields"><div class="cfields-t">✍️ '+esc(PRODUCT.cf_title||"Personnalisation")+'</div>';
  for(var i=0;i<cf.length;i++){
    var f = cf[i], val = (st.units[u].cf||{})[f.key]||"";
    h += '<div class="cfield-w"><label class="cfield-l">'+esc(f.label)+(f.required?' <b>*</b>':'')+'</label>'
       + '<input class="cfield" type="text" maxlength="60" data-u="'+u+'" placeholder="'+esc(f.ph||"")+'"'
       + ' value="'+esc(val)+'" oninput="cfSet('+u+',\''+esc(f.key)+'\',this.value)" onclick="event.stopPropagation()"></div>';
  }
  return h + '</div>';
}
function selectorsBlock(qty){
  var hasCf = PRODUCT.custom_fields && PRODUCT.custom_fields.length;
  if((!PRODUCT.colors||!PRODUCT.colors.length) && (!PRODUCT.sizes||!PRODUCT.sizes.length) && !hasCf) return "";
  ensureUnits(qty);
  var hasColors = PRODUCT.colors && PRODUCT.colors.length;
  var rows = "";
  for(var u=0; u<qty; u++){
    var lab = qty>1 ? ('<span class="un">#'+(u+1)+'</span>') : '';
    // miniatura del colore selezionato di questa unità (cambia con la selezione)
    var thumb = hasColors ? '<img class="unitimg" data-u="'+u+'" src="'+esc(colorImg(st.units[u].color))+'" alt="">' : '';
    rows += '<div class="unit">'+lab+thumb+optSelect("color",u)+optSelect("size",u)+cfInputs(u)+'</div>';
  }
  // stopPropagation: cliccare i selettori NON deve far ripartire selectRow
  return '<div class="units show" onclick="event.stopPropagation()">'+rows+'</div>';
}
function bundlesInnerHTML(){
  return OFFER.quantities.map(function(row, i){
    var c = calc(row);
    var isOn = i===selectedIdx;
    var badge = row.badge_text ? '<span class="badge">'+esc(row.badge_text)+'</span>' : '';
    var ribbon = row.popular_text ? '<span class="ribbon">'+esc(row.popular_text)+'</span>' : '';
    var pill = "";
    if(c.save > 0.01){
      pill = PRODUCT.discount_display==="percent"
        ? '<span class="pill">-'+c.pct+'%</span>'
        : '<span class="pill">'+(PRODUCT.save_word||"Save")+' '+money(c.save)+'</span>';
    }
    var was = c.orig > c.final+0.01 ? '<div class="was">'+money(c.orig)+'</div>' : '';
    return '<div class="bnd'+(isOn?' on':'')+'" onclick="selectRow('+i+')">'+badge+ribbon
      + '<div class="row"><span class="rad"></span>'
      + (PRODUCT.thumb? '<img class="thumb" src="'+esc(PRODUCT.thumb)+'" alt="">':'')
      + '<div class="mid"><div class="tt"><b>'+esc(row.title)+'</b>'+pill+'</div>'
      + (row.subtitle?'<div class="sub">'+esc(row.subtitle)+'</div>':'')+'</div>'
      + '<div class="pr"><div class="now">'+money(c.final)+'</div>'+was+'</div></div>'
      + (isOn?selectorsBlock(row.quantity):"")+'</div>';
  }).join("");
}
function renderBundles(){
  var host = document.getElementById("bundles");
  if(!host) return;   // modo Releasit: no hay bloque #bundles propio (el selector de packs vive en lp-buy) -> no renderizar
  host.innerHTML = bundlesInnerHTML();
  updateCTA();
  if(window._qbSync){ try{ window._qbSync(); }catch(e){} }   // sincronizza lo sticky quick-buy sheet
}
function selectRow(i){ selectedIdx = i; window._lpTouched=true; renderBundles(); }
function onOpt(el){
  window._lpTouched=true;                 // l'utente ha scelto → il sync live NON deve piu azzerare st.units
  var u=+el.getAttribute("data-u"), k=el.getAttribute("data-k");
  st.units[u][k] = el.value;
  if(k==="color"){                       // cambia la miniatura dell'unità (buy box + sheet) + la gallery
    var ims=document.querySelectorAll('.unitimg[data-u="'+u+'"]');
    for(var _q=0;_q<ims.length;_q++) ims[_q].src=colorImg(el.value);
    try{ galShowColor && galShowColor(el.value); }catch(e){}
  }
}
function updateCTA(){
  var row = OFFER.quantities[selectedIdx]; if(!row) return;   // modo Releasit: sin OFFER propio -> no tocar #stPrice (lo gestiona lp-buy)
  var c = calc(row);
  var was = c.orig > c.final+0.01 ? ' <span class="was">'+money(c.orig)+'</span>' : '';
  var t = document.getElementById("ctaText"); if(t) t.innerHTML = (PRODUCT.atc||"Add to cart") + " — " + money(c.final) + was;
  var sp = document.getElementById("stPrice");
  if(sp) sp.innerHTML = money(c.final) + (c.orig>c.final+0.01?' <span class="w">'+money(c.orig)+'</span>':'');
  var kl = document.getElementById("klAmt"); if(kl) kl.innerHTML = money(c.final/4);
}
// Risolve il variant id: chiave esatta "color|size", poi fallback SOLO SE UNIVOCO (solo-colore,
// solo-size, unica variante, match singolo). MAI una variante arbitraria: prima l'ultimo fallback era
// vm[keys[0]] → una combo mancante mandava al checkout la variante SBAGLIATA (reso garantito).
function resolveVariant(color, size){
  var vm = PRODUCT.variant_map||{}, keys=Object.keys(vm);
  if(!keys.length) return null;
  color=color||""; size=size||"";
  if(vm[color+"|"+size]) return vm[color+"|"+size];
  if(!size && vm[color+"|"]) return vm[color+"|"];
  if(!color && vm["|"+size]) return vm["|"+size];
  if(keys.length===1) return vm[keys[0]];
  var mc=[], ms=[];
  for(var i=0;i<keys.length;i++){ var p=keys[i].split("|");
    if(color && p[0]===color) mc.push(keys[i]); if(size && p[1]===size) ms.push(keys[i]); }
  if(mc.length===1) return vm[mc[0]];
  if(ms.length===1) return vm[ms[0]];
  return null;
}
// v268: AUTORITATIVO — legge la selezione VISIBILE dal DOM proprio prima del checkout, dallo sheet
// sticky se aperto altrimenti dal buy box classico. NON si fida di onchange/onOpt né dello stato
// interno (che sync/timing/re-render potevano lasciare ai default): quello che l'utente VEDE
// selezionato (tier .bnd.on + valori dei <select>) è ciò che finisce nel carrello. Vale per ENTRAMBI
// i percorsi (sticky e classico) → una sola fonte di verità.
function readSelectionFromDOM(){
  // UNA sola fonte: il bundle VERO #bundles (nel buy box, o dentro lo sheet sticky quando è aperto).
  var host = document.getElementById("bundles");
  if(!host) return;
  var bnds = host.querySelectorAll(".bnd");
  for(var i=0;i<bnds.length;i++){ if(bnds[i].classList.contains("on")){ selectedIdx=i; break; } }
  var q = OFFER.quantities[selectedIdx]; if(!q) return;
  ensureUnits(q.quantity);
  var sels = host.querySelectorAll("select[data-u]");
  for(var s=0;s<sels.length;s++){ var u=+sels[s].getAttribute("data-u"), k=sels[s].getAttribute("data-k");
    if(u<q.quantity && (k==="color"||k==="size")){ st.units[u][k]=sels[s].value; } }
}
/* COD / Releasit: la compra pasa por el formulario de Releasit (app block dentro de #lpReleasitHost).
   Sin /cart/clear.js, sin /cart/add.js, sin redirect a /checkout, sin eventos de pixel. */
function addBundle(e){
  if(e && e.preventDefault) e.preventDefault();
  try{ readSelectionFromDOM(); }catch(_e){}
  if(typeof window.lpOpenReleasit==="function"){
    try{ if(window.lpOpenReleasit()!==false) return; }catch(_e){}
  }
  scrollBundles();
}
/* ============ CART DRAWER ============ */
function cartMoney(cents){ return PRODUCT.cur + CUR_SEP + (cents/100).toFixed(2).replace(".", DEC_SEP); }
var _cartCdStarted=false;
function cartEtaText(){
  var loc=(PRODUCT&&PRODUCT.locale)||"en-GB", o={day:"numeric",month:"short"};
  var a=new Date(); a.setDate(a.getDate()+2); var b=new Date(); b.setDate(b.getDate()+4);  // 2-4 giorni (come landing)
  try{ return a.toLocaleDateString(loc,o)+" – "+b.toLocaleDateString(loc,o); }catch(e){ return ""; }
}
function startCartCd(){
  if(_cartCdStarted) return; var el=document.getElementById("cartCd"); if(!el) return; _cartCdStarted=true;
  var end=Date.now()+10*60*1000;
  (function t(){ var d=Math.max(0,end-Date.now()); var m=Math.floor(d/60000), s=Math.floor(d%60000/1000);
    el.textContent=(m<10?"0":"")+m+":"+(s<10?"0":"")+s; if(d>0) setTimeout(t,1000); })();
}
function cartOpen(){ var d=document.getElementById("cartDr"), o=document.getElementById("cartOv"); if(d)d.classList.add("open"); if(o)o.classList.add("open"); document.body.style.overflow="hidden";
  var e=document.getElementById("cartEta"); if(e) e.textContent=cartEtaText(); startCartCd(); cartLoad(); }
function cartClose(){ var d=document.getElementById("cartDr"), o=document.getElementById("cartOv"); if(d)d.classList.remove("open"); if(o)o.classList.remove("open"); document.body.style.overflow=""; }
function cartLoad(){
  if(typeof window.fetch!=="function") return;
  fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
    var cnt=document.getElementById("cartCount"); if(cnt){ cnt.textContent=c.item_count; cnt.style.display=c.item_count?"":"none"; }
    var hn=document.getElementById("cartHN"); if(hn) hn.textContent="("+c.item_count+")";
    var tot=document.getElementById("cartTotal"); if(tot) tot.textContent=cartMoney(c.total_price);
    var body=document.getElementById("cartItems"), dr=document.getElementById("cartDr"); if(!body) return;
    if(!c.items.length){ body.innerHTML='<div class="cart-empty">'+(dr?dr.getAttribute("data-empty"):"")+'</div>'; return; }
    var trash='<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>';
    body.innerHTML=c.items.map(function(it){
      var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/,'_120x$1$2'):"";
      return '<div class="citem"><img src="'+esc(img)+'" alt=""><div class="ci-info"><b>'+esc(it.product_title)+'</b>'+
        '<span>'+esc(it.variant_title&&it.variant_title!=="Default Title"?it.variant_title:"")+'</span>'+
        '<div class="ci-q"><button onclick="cartQty(\''+it.key+'\','+(it.quantity-1)+')">-</button><span>'+it.quantity+'</span>'+
        '<button onclick="cartQty(\''+it.key+'\','+(it.quantity+1)+')">+</button></div></div>'+
        '<div class="ci-r"><button class="ci-trash" title="Rimuovi" aria-label="rimuovi" onclick="cartQty(\''+it.key+'\',0)">'+trash+'</button>'+
        '<div class="ci-p">'+cartMoney(it.final_line_price)+'</div></div></div>';
    }).join("");
  }).catch(function(){});
}
function cartQty(key, q){
  fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:key,quantity:Math.max(0,q)})})
   .then(function(r){return r.json();}).then(function(){ cartLoad(); }).catch(function(){});
}
function cartCheckout(){
  // (pixel fbq eliminado: sin tracking inline)
  fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
    var q=c.item_count, codes=PRODUCT.discount_codes||{}, code=codes[q]||codes[String(q)]||"";
    if(!code){ var best=0; for(var k in codes){ var n=parseInt(k,10); if(n<=q && n>best) best=n; } if(best) code=codes[best]||codes[String(best)]; }
    window.location.href = code ? ("/discount/"+encodeURIComponent(code)+"?redirect=/checkout") : "/checkout";
  }).catch(function(){ window.location.href="/checkout"; });
}
cartLoad();
// INDIETRO dal checkout (bfcache, soprattutto mobile): la pagina tornava col bottone
// DISABILITATO (lo stato "sto aggiungendo" veniva congelato) → CTA morto. Reset al ripristino.
window.addEventListener("pageshow", function(e){
  if(e && e.persisted){
    var b=document.getElementById("ctaBtn"); if(b){ b.style.opacity=""; b.disabled=false; }
    try{ cartLoad(); }catch(_e){}
  }
});
// arrivo da /cart (redirect home): apri automaticamente il drawer del carrello
if((location.hash==="#cart")||/[?&]cart=1(&|$)/.test(location.search)){ setTimeout(cartOpen,180); }
function scrollBundles(e){ if(e && e.preventDefault) e.preventDefault();
  // Releasit: el selector de packs es #lpBundles y el boton vive en #lpReleasitHost (fallback: #bundles clasico)
  var b=document.getElementById("bundles")||document.getElementById("lpBundles")||document.getElementById("lpReleasitHost");
  if(b) b.scrollIntoView({behavior:"smooth",block:"center"}); }

OFFER.quantities.forEach(function(r,i){ if(r.preselected) selectedIdx=i; });
renderBundles();

/* ============ SYNC LIVE da Shopify: prezzo + varianti (colori/taglie/variant_map) ============ */
(function(){
  if(!PRODUCT.handle || typeof window.fetch!=="function") return;
  // inofensivo si falla (404/HTML/red): todo dentro de try + .catch
  try{ fetch("/products/"+PRODUCT.handle+".js").then(function(r){return r.json();}).then(function(p){
    if(!p) return; var ch=false, struct=false;   // struct = colori/taglie CAMBIATI (add/remove) → serve reset unità
    // prezzo (con lo sconto automatico fisso, il display coincide col checkout)
    var v0=p.variants&&p.variants[0];
    if(v0){ var live=(v0.price||0)/100, comp=(v0.compare_at_price||0)/100;
      if(live>0 && Math.abs(live-PRODUCT.rawPrice)>0.001){ PRODUCT.rawPrice=live; ch=true; }
      if(comp>0 && Math.abs(comp-PRODUCT.comparePrice)>0.001){ PRODUCT.comparePrice=comp; ch=true; } }
    // varianti live: se aggiungi/togli colori o taglie su Shopify, i selettori si aggiornano
    if(p.options && p.variants && p.variants.length){
      var ci=-1, si=-1;
      p.options.forEach(function(o,idx){ var n=(o.name||"").toLowerCase();
        if(/coul|color|colore|farbe|kleur/.test(n)) ci=idx;
        else if(/size|taille|taglia|talla|gr|maat|pointure/.test(n)) si=idx; });
      // FALLBACK POSIZIONALE (rispecchia il server: option1 = dimensione PRIMARIA). Se nessuna opzione ha un
      // nome "colore" riconosciuto (es. 'Parfum', 'Modèle', 'Fragranza', 'Style'), la primaria è la prima opzione
      // che NON è la taglia. SENZA questo, vmap diventava {"|":id} e addBundle dava 'Sélection indisponible'.
      if(ci<0){ for(var _oi=0; _oi<p.options.length; _oi++){ if(_oi!==si){
        var _ov=(p.options[_oi]||{}).values||[];
        // SALTA il placeholder Shopify dei prodotti senza varianti reali ('Title'/'Default Title'):
        // NON è una dimensione → altrimenti si creava un selettore fantasma e la chiave 'Default Title|'
        // non combaciava con la ricerca '|' della pagina.
        if(((p.options[_oi].name||"").toLowerCase()==="title") || (_ov.length===1 && _ov[0]==="Default Title")) continue;
        ci=_oi; break;
      } } }
      var colors=[], sizes=[], vmap={};
      p.variants.forEach(function(v){
        var opts=[v.option1,v.option2,v.option3];
        var co=ci>=0?(opts[ci]||""):"", sz=si>=0?(opts[si]||""):"";
        if(co && colors.indexOf(co)<0) colors.push(co);
        if(sz && sizes.indexOf(sz)<0) sizes.push(sz);
        vmap[co+"|"+sz]=v.id;
      });
      if(colors.length && colors.join("|")!==(PRODUCT.colors||[]).join("|")){ PRODUCT.colors=colors; ch=true; struct=true; }
      if(sizes.length && sizes.join("|")!==(PRODUCT.sizes||[]).join("|")){ PRODUCT.sizes=sizes; ch=true; struct=true; }
      if(Object.keys(vmap).length){ PRODUCT.variant_map=vmap; }
      // mappa colore->immagine dalle varianti linkate (featured_image) -> miniatura bundle live
      var cimg={};
      p.variants.forEach(function(v){
        var opts=[v.option1,v.option2,v.option3];
        var co=ci>=0?(opts[ci]||""):""; var fi=v.featured_image; var src=fi?(fi.src||fi):"";
        if(co && src && !cimg[co]){ cimg[co]=(String(src).indexOf("//")===0?"https:":"")+src; }
      });
      if(Object.keys(cimg).length){ PRODUCT.color_images=cimg; ch=true; }
    }
    // BUGFIX 2026-08-28: prima si azzerava st.units a OGNI sync (ch era sempre true perché color_images
    // si riscrive sempre) → se la sync arrivava DOPO che l'utente aveva scelto colore/taglia nei bundle,
    // CANCELLAVA le scelte → al checkout finivano le varianti di DEFAULT (colore/taglia/immagine sbagliati).
    // Ora si azzera SOLO se colori/taglie sono cambiati davvero (struct); per prezzo/immagini si ri-renderizza
    // soltanto, preservando le selezioni (renderBundles→ensureUnits non le tocca).
    // v263: NON azzerare/re-renderizzare se l'utente ha GIA' scelto (sheet aperto o variante toccata):
    // il sync arrivava DOPO la selezione e la cancellava → checkout con taglia/colore di DEFAULT.
    if(struct && !window._lpTouched){ st={units:[]}; }   // reset SOLO se colori/taglie cambiati e utente non ha ancora scelto
    // v267: NON ri-renderizzare dopo che l'utente ha aperto lo sheet/scelto: su rete lenta il fetch
    // /products.js poteva risolvere DOPO le selezioni e RICOSTRUIRE i <select> → disturbava il picker
    // aperto e (se un onchange non era ancora scattato) riportava i menu ai default → checkout errato.
    if(ch && !window._lpTouched){ renderBundles(); updateCTA(); }
    else if(ch){ updateCTA(); }                           // prezzo/immagini aggiornati senza toccare i select
    // sync IMMAGINI: se aggiungi/togli foto prodotto su Shopify, la gallery si aggiorna da sola
    try{
      if(p.images && p.images.length){
        var norm=function(u){ u=(u||""); if(u.indexOf("//")===0)u="https:"+u; return u.split("?")[0]; };
        var live=p.images.map(norm);
        var track=document.getElementById("galTrack");
        var cur=Array.prototype.slice.call(document.querySelectorAll("#galTrack .galslide")).map(function(el){
          var m=(el.style.backgroundImage||"").match(/url\(["']?([^"')]+)/); return norm(m?m[1]:""); });
        // NON sovrascrivere la gallery della pagina (le modifiche dall'editor devono restare):
        // ricostruisci dal prodotto SOLO se la pagina non ha ancora nessuna immagine.
        if(track && !cur.length && live.length){
          track.innerHTML=live.map(function(u){ return '<div class="galslide" style="background-image:url('+u+')"><img src="'+u+'" alt=""></div>'; }).join("");
          var th=document.getElementById("galThumbs");
          if(th) th.innerHTML=live.map(function(u,i){ return '<img class="'+(i===0?"on":"")+'" data-i="'+i+'" src="'+u+'" alt="">'; }).join("");
          GAL_I=0; galSync();
        }
      }
    }catch(e){}
  }).catch(function(){}); }catch(_e){}
})();

/* ============ URGENCY countdown ============ */
(function(){
  var el=document.getElementById("cd"); if(!el) return;
  var end=Date.now()+ (14*60+59)*1000;
  (function tick(){
    var d=Math.max(0,end-Date.now());
    var h=Math.floor(d/3600000), m=Math.floor(d%3600000/60000), s=Math.floor(d%60000/1000);
    el.textContent=(h<10?"0":"")+h+":"+(m<10?"0":"")+m+":"+(s<10?"0":"")+s;
    if(d>0) setTimeout(tick,1000);
  })();
})();

/* ============ STICKY on scroll ============ */
(function(){
  // disparador: el host del boton Releasit (#lpReleasitHost); fallback al CTA clasico #ctaBtn
  var cta=document.getElementById("lpReleasitHost")||document.getElementById("ctaBtn"), bar=document.getElementById("sticky"); if(!cta||!bar) return;
  function upd(){ bar.classList.toggle("show", cta.getBoundingClientRect().bottom < -10); }
  window.addEventListener("scroll", upd, {passive:true});
  window.addEventListener("resize", upd, {passive:true});
  upd();
})();

/* ============ QUICK-BUY sticky sheet (v269 — SPOSTA il bundle vero) ============
   Invece di CLONARE il bundle (#qbBundles), lo sheet OSPITA il bundle classico VERO (#bundles):
   lo sposta dentro il foglio all'apertura e lo rimette al suo posto alla chiusura. UNA sola fonte di
   verità (stessi <select>, stesso stato, stessi eventi del buy box) → impossibile che sheet e checkout
   divergano. Animazione via `bottom` (NIENTE transform: i <select> nativi iOS dentro un contenitore
   trasformato potevano non committare la scelta). Gated su PRODUCT.stickyVar; salta COD + custom_fields. */
(function(){
  if(!PRODUCT.stickyVar || PRODUCT.cod) return;
  if(PRODUCT.custom_fields && PRODUCT.custom_fields.length) return;
  var barEl=document.getElementById("sticky"); if(!barEl) return;
  var trigger=barEl.querySelector("button"); if(!trigger) return;
  var host=document.querySelector(".pgx")||document.body;
  var ov, sheet, slot, built=false, isOpen=false, ph=null;
  function injectCSS(){ if(document.getElementById("qbStyles")) return;
    var s=document.createElement("style"); s.id="qbStyles";
    s.textContent=".qb-ov{position:fixed;inset:0;background:rgba(10,10,14,.5);opacity:0;visibility:hidden;transition:opacity .25s;z-index:9998}.qb-ov.on{opacity:1;visibility:visible}"
     +".qb-sheet{position:fixed;left:0;right:0;bottom:-108vh;z-index:9999;background:var(--bg,#fff);color:var(--ink,#16161a);border-radius:20px 20px 0 0;box-shadow:0 -12px 40px rgba(0,0,0,.22);transition:bottom .32s cubic-bezier(.22,1,.36,1);max-height:92vh;display:flex;flex-direction:column;max-width:560px;margin:0 auto}.qb-sheet.on{bottom:0}"
     +".qb-hd{display:flex;align-items:center;gap:12px;padding:16px 18px 6px}.qb-hd img{width:50px;height:58px;object-fit:cover;border-radius:10px;border:1px solid var(--line,#eee)}.qb-hd .t{flex:1;min-width:0}.qb-hd .t b{display:block;font-size:15px;line-height:1.2}.qb-hd .t span{font-size:12.5px;color:var(--ink3,#8a867d)}"
     +".qb-x{border:0;background:var(--bg2,#f2f0ec);width:32px;height:32px;border-radius:50%;font-size:20px;line-height:1;cursor:pointer;color:var(--ink2,#555);flex:0 0 auto}"
     +".qb-body{overflow:auto;padding:6px 18px 12px;-webkit-overflow-scrolling:touch}.qb-body .bundles{display:flex;flex-direction:column;gap:11px}"
     +".qb-ft{border-top:1px solid var(--line,#eee);padding:12px 18px calc(12px + env(safe-area-inset-bottom));display:flex;align-items:center;gap:14px;background:var(--bg,#fff)}.qb-tot .now{font-weight:800;font-size:19px;color:var(--ink,#16161a)}.qb-tot .was{font-size:12.5px;color:var(--ink3,#b9b4aa);text-decoration:line-through;margin-left:6px}"
     +".qb-go{flex:1;border:0;border-radius:13px;background:var(--ink,#16161a);color:#fff;font-size:15.5px;font-weight:800;padding:16px;cursor:pointer}.qb-go:active{opacity:.9}@media(prefers-reduced-motion:reduce){.qb-sheet,.qb-ov{transition:none}}";
    document.head.appendChild(s);
  }
  function build(){ injectCSS();
    ov=document.createElement("div"); ov.className="qb-ov"; ov.addEventListener("click",close);
    sheet=document.createElement("div"); sheet.className="qb-sheet"; sheet.setAttribute("role","dialog"); sheet.setAttribute("aria-modal","true");
    sheet.innerHTML='<div class="qb-hd"><img src="'+esc(PRODUCT.thumb||"")+'" alt=""><div class="t"><b>'+esc(PRODUCT.name||"")+'</b><span>'+esc(PRODUCT.instock||"")+'</span></div><button class="qb-x" aria-label="close">&times;</button></div>'
      +'<div class="qb-body"><div class="bundhead"><b>'+esc(PRODUCT.bundle_head||"")+'</b><span class="l"></span></div><div class="qb-slot" id="qbSlot"></div></div>'
      +'<div class="qb-ft"><div class="qb-tot" id="qbTot"></div><button class="qb-go">'+esc(PRODUCT.sticky_go||PRODUCT.atc||"Checkout")+' →</button></div>';
    host.appendChild(ov); host.appendChild(sheet);
    slot=sheet.querySelector("#qbSlot");
    sheet.querySelector(".qb-x").addEventListener("click",close);
    sheet.querySelector(".qb-go").addEventListener("click",go);
    built=true; window._qbSync=syncTot;
  }
  // SPOSTA il vero #bundles nel foglio (lasciando un segnaposto per rimetterlo esatto al suo posto)
  function moveIn(){ var b=document.getElementById("bundles"); if(!b||!slot||b.parentNode===slot) return;
    ph=document.createComment("qb-bundles"); b.parentNode.insertBefore(ph,b); slot.appendChild(b); }
  function moveOut(){ var b=document.getElementById("bundles");
    if(b && ph && ph.parentNode){ ph.parentNode.insertBefore(b,ph); ph.parentNode.removeChild(ph); } ph=null; }
  function syncTot(){ if(!built) return; var c=calc(OFFER.quantities[selectedIdx]); var tot=document.getElementById("qbTot");
    if(tot) tot.innerHTML='<span class="now">'+money(c.final)+'</span>'+(c.orig>c.final+0.01?'<span class="was">'+money(c.orig)+'</span>':''); }
  function openSheet(){ if(!built) build(); moveIn(); isOpen=true; window._lpTouched=true; syncTot();
    requestAnimationFrame(function(){ ov.classList.add("on"); sheet.classList.add("on"); }); document.body.style.overflow="hidden"; }
  function close(){ if(!built) return; isOpen=false; ov.classList.remove("on"); sheet.classList.remove("on"); document.body.style.overflow="";
    setTimeout(function(){ if(!isOpen) moveOut(); }, 350); }   // rimette il bundle al suo posto DOPO l'animazione
  // addBundle è AUTORITATIVO: legge il bundle VERO (#bundles, ora nel foglio) all'istante del checkout.
  function go(){ addBundle(); close(); }
  trigger.onclick=function(e){ if(e&&e.preventDefault) e.preventDefault(); openSheet(); };
})();

/* ============ UGC VIDEO — fascia full-width sotto il buy box (v266, senior redesign) ============
   Sezione a tema (Space Grotesk, accent, .wrapx) INSERITA dopo la sezione .buy → respira su desktop
   (prima era compressa nella colonna del buy box). Card 9:16 con reveal animato + hover zoom; player
   custom TikTok-style (tap play/pause, progress-bar seekabile, mute, swipe, contatore, tastiera).
   Preview autoplay MUTE solo quando visibili (IntersectionObserver → batteria/perf). Min 3 visibili
   su mobile, 1 centrata se singolo. Gated su PRODUCT.buy_videos → pagine senza video intatte. */
(function(){
  var ICON_PLAY='<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
  var ICON_PAUSE='<svg viewBox="0 0 24 24"><path d="M7 5h4v14H7zm6 0h4v14h-4z"/></svg>';
  var ICON_MUTE='<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 5V4L8 9H4z"/><path d="M16 9l5 5m0-5l-5 5" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
  var ICON_SOUND='<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 5V4L8 9H4z"/><path d="M16 8a5 5 0 0 1 0 8" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
  var ICON_STAR='<svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.3 6.9.7-5.2 4.6 1.5 6.8L12 17.8 5.9 20.4l1.5-6.8L2.2 9l6.9-.7z"/></svg>';

  function init(){
    var vids = PRODUCT.buy_videos || [];
    if(!vids.length) return;
    if(document.getElementById("bvSec")) return;                 // idempotente
    var buy = document.querySelector(".buy");
    var anchor = buy || document.querySelector(".buy .info .pays") || document.querySelector(".buy .info");
    if(!anchor) return;
    injectCSS();
    window._bvVids = vids;
    // etichette: usa quelle salvate nel PRODUCT, altrimenti FALLBACK per lingua (pagine vecchie
    // costruite prima delle label → così l'header non resta mai vuoto e la sezione è completa)
    var LANG=((PRODUCT.locale||"en").slice(0,2)).toLowerCase();
    var DEF=({it:["Video","Lo usano così","Recensioni video di clienti reali","Tocca per l'audio"],
              fr:["En vidéo","Ils l'utilisent","Avis vidéo de vrais clients","Touchez pour le son"],
              es:["En vídeo","Así lo usan","Reseñas en vídeo de clientes reales","Toca para el audio"],
              de:["Im Video","So nutzen sie es","Video-Bewertungen echter Kunden","Für Ton tippen"],
              en:["In video","See it in action","Real customer video reviews","Tap for sound"]})[LANG]
             ||["In video","See it in action","Real customer video reviews","Tap for sound"];
    var bvEyb=PRODUCT.bv_eyb||DEF[0], bvTitle=PRODUCT.bv_title||DEF[1], bvSub=PRODUCT.bv_sub||DEF[2];
    var one = vids.length===1;
    var cards = vids.map(function(v,i){
      var poster = v.poster? ' poster="'+esc(v.poster)+'"' : '';
      return '<button class="bvc" data-i="'+i+'" style="transition-delay:'+(i*80)+'ms" aria-label="Video '+(i+1)+'"><span class="bvmedia">'
        + '<video class="bvv" muted loop playsinline preload="metadata" webkit-playsinline'+poster+'>'
        + '<source src="'+esc(v.video||"")+'" type="video/mp4"></video>'
        + '<span class="bvgrad" aria-hidden="true"></span>'
        + '<span class="bvplay" aria-hidden="true">'+ICON_PLAY+'</span>'
        + '<span class="bvmini" aria-hidden="true">'+ICON_MUTE+'</span></span></button>';
    }).join("");
    var sec = document.createElement("section");
    sec.className = "bvsec reveal"; sec.id = "bvSec";
    sec.innerHTML = '<div class="wrapx"><div class="bvinner">'
      + '<div class="bvhead">'
      + '<span class="bveyb"><span class="bvdot"></span>'+esc(bvEyb)+'</span>'
      + '<h2 class="bvtitle">'+esc(bvTitle)+'</h2>'
      + (bvSub?'<p class="bvsub">'+esc(bvSub)+'</p>':'')
      + '<span class="bvline" aria-hidden="true"></span>'
      + '</div>'
      + '<div class="bvviewport">'
      + (one?'':'<button class="bvarr prev" aria-label="prev"><svg viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6"/></svg></button>')
      + '<div class="bvstrip'+(one?' one':'')+'">'+cards+'</div>'
      + (one?'':'<button class="bvarr next" aria-label="next"><svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg></button>')
      + '</div></div></div>';
    if(buy){ buy.parentNode.insertBefore(sec, buy.nextSibling); }
    else { anchor.parentNode.insertBefore(sec, anchor.nextSibling); }
    // colore sezione: default = tema pagina; override dall'editor (PRODUCT.bv_accent, es. tema verde)
    if(PRODUCT.bv_accent){ try{ sec.style.setProperty("--bva", PRODUCT.bv_accent);
      sec.style.setProperty("--bva2", "color-mix(in srgb,"+PRODUCT.bv_accent+" 78%,#000)"); }catch(e){} }

    // reveal (l'observer di pagina è già girato: ne uso uno mio per il blocco iniettato)
    if("IntersectionObserver" in window){
      var rio=new IntersectionObserver(function(en){en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); rio.unobserve(e.target); } });},{threshold:.1});
      rio.observe(sec);
    } else { sec.classList.add("in"); }

    // preview: autoplay MUTO solo quando visibile
    var previews = sec.querySelectorAll("video.bvv");
    if("IntersectionObserver" in window){
      var io = new IntersectionObserver(function(ents){ ents.forEach(function(e){ var v=e.target;
        if(e.isIntersecting){ v.play&&v.play().catch(function(){}); } else { v.pause&&v.pause(); } }); }, {threshold:0.4});
      for(var p=0;p<previews.length;p++) io.observe(previews[p]);
    } else { for(var q=0;q<previews.length;q++){ try{ previews[q].play&&previews[q].play().catch(function(){}); }catch(e){} } }

    // tap card -> player
    var btns = sec.querySelectorAll(".bvc");
    for(var b=0;b<btns.length;b++){ btns[b].addEventListener("click", function(){ openFull(+this.getAttribute("data-i")); }); }

    // UX carosello: frecce + sfumatura ai bordi SOLO quando ci sono troppi video (scrollabile),
    // drag-to-scroll col mouse, stato frecce ai bordi. Gestisce bene 3 o 10+ video.
    var strip = sec.querySelector(".bvstrip");
    var vp = sec.querySelector(".bvviewport");
    var prevA = sec.querySelector(".bvarr.prev"), nextA = sec.querySelector(".bvarr.next");
    function updArr(){
      var can = strip.scrollWidth > strip.clientWidth + 4;
      vp.classList.toggle("bvscroll", can);                    // attiva frecce + mask solo se serve scorrere
      if(prevA){ prevA.disabled = strip.scrollLeft<=4; nextA.disabled = strip.scrollLeft+strip.clientWidth>=strip.scrollWidth-4; }
    }
    var step = function(){ return Math.max(200, strip.clientWidth*0.7); };
    if(prevA){ prevA.addEventListener("click",function(){ strip.scrollBy({left:-step(),behavior:"smooth"}); });
      nextA.addEventListener("click",function(){ strip.scrollBy({left:step(),behavior:"smooth"}); }); }
    strip.addEventListener("scroll",updArr,{passive:true});
    window.addEventListener("resize",updArr);
    setTimeout(updArr,80); setTimeout(updArr,500);
    // drag-to-scroll (mouse/trackpad su desktop); blocca l'apertura del player se stavi trascinando
    var down=false,sx0=0,sl0=0,moved=false;
    strip.addEventListener("mousedown",function(e){ down=true; moved=false; sx0=e.pageX; sl0=strip.scrollLeft; strip.classList.add("grab"); });
    window.addEventListener("mousemove",function(e){ if(!down)return; var dx=e.pageX-sx0; if(Math.abs(dx)>5) moved=true; strip.scrollLeft=sl0-dx; });
    window.addEventListener("mouseup",function(){ if(down){ down=false; strip.classList.remove("grab"); } });
    strip.addEventListener("click",function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } },true);
  }

  /* ---------- PLAYER custom TikTok-style ---------- */
  var ov, ovVideo, bar, bigIcon, counter, muteBtn, caption, capStars, capName, capText, curIdx=0, muted=false, flashT;
  function build(){
    ov=document.createElement("div"); ov.className="bvov";
    ov.innerHTML='<button class="bvnav prev" aria-label="prev"><svg viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6"/></svg></button>'
      +'<div class="bvstage">'
      +'<video class="bvfull" playsinline webkit-playsinline preload="auto"></video>'
      +'<div class="bvtapzone"></div>'
      +'<div class="bvbig" aria-hidden="true">'+ICON_PLAY+'</div>'
      +'<div class="bvtop"><button class="bvmute" aria-label="audio">'+ICON_SOUND+'</button><span class="bvcount"></span></div>'
      +'<div class="bvcap"><div class="bvstars" id="bvStars"></div><b class="bvcapn" id="bvCapN"></b><div class="bvcapt" id="bvCapT"></div></div>'
      +'<div class="bvprog"><i class="bvbar"></i></div>'
      +'</div>'
      +'<button class="bvnav next" aria-label="next"><svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg></button>'
      +'<button class="bvx" aria-label="chiudi">&times;</button>';
    (document.querySelector(".pgx")||document.body).appendChild(ov);
    ovVideo=ov.querySelector(".bvfull"); bar=ov.querySelector(".bvbar");
    bigIcon=ov.querySelector(".bvbig"); counter=ov.querySelector(".bvcount"); muteBtn=ov.querySelector(".bvmute");
    caption=ov.querySelector(".bvcap"); capStars=ov.querySelector("#bvStars"); capName=ov.querySelector("#bvCapN"); capText=ov.querySelector("#bvCapT");
    ov.querySelector(".bvx").addEventListener("click",closeFull);
    ov.addEventListener("click",function(e){ if(e.target===ov) closeFull(); });
    ov.querySelector(".bvnav.prev").addEventListener("click",function(e){ e.stopPropagation(); step(-1); });
    ov.querySelector(".bvnav.next").addEventListener("click",function(e){ e.stopPropagation(); step(1); });
    ov.querySelector(".bvtapzone").addEventListener("click",togglePlay);
    muteBtn.addEventListener("click",function(e){ e.stopPropagation(); muted=!muted; ovVideo.muted=muted; muteBtn.innerHTML=muted?ICON_MUTE:ICON_SOUND; });
    ovVideo.addEventListener("timeupdate",function(){ if(ovVideo.duration) bar.style.width=(ovVideo.currentTime/ovVideo.duration*100)+"%"; });
    ov.querySelector(".bvprog").addEventListener("click",function(e){ e.stopPropagation(); var r=this.getBoundingClientRect(); if(ovVideo.duration) ovVideo.currentTime=((e.clientX-r.left)/r.width)*ovVideo.duration; });
    // swipe (mobile): orizzontale = prev/next, giù = chiudi
    var sx=0,sy=0;
    ov.addEventListener("touchstart",function(e){ var t=e.changedTouches[0]; sx=t.clientX; sy=t.clientY; },{passive:true});
    ov.addEventListener("touchend",function(e){ var t=e.changedTouches[0], dx=t.clientX-sx, dy=t.clientY-sy;
      if(Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)){ step(dx<0?1:-1); }
      else if(dy>90 && dy>Math.abs(dx)){ closeFull(); } },{passive:true});
    document.addEventListener("keydown",function(e){ if(!ov||!ov.classList.contains("on"))return;
      if(e.key==="Escape")closeFull(); else if(e.key==="ArrowRight")step(1); else if(e.key==="ArrowLeft")step(-1);
      else if(e.key===" "){ e.preventDefault(); togglePlay(); } });
  }
  function togglePlay(){ if(!ovVideo)return;
    if(ovVideo.paused){ ovVideo.play&&ovVideo.play().catch(function(){}); flash(ICON_PLAY); }
    else { ovVideo.pause(); flash(ICON_PAUSE); } }
  function flash(icon){ if(!bigIcon)return; bigIcon.innerHTML=icon; bigIcon.classList.add("show");
    clearTimeout(flashT); flashT=setTimeout(function(){ bigIcon.classList.remove("show"); },420); }
  function openFull(i){
    var vids=window._bvVids||PRODUCT.buy_videos||[]; if(!vids.length)return;
    curIdx=i; if(!ov) build();
    var single=vids.length<2;
    ov.querySelector(".bvnav.prev").style.display=single?"none":"";
    ov.querySelector(".bvnav.next").style.display=single?"none":"";
    load();
    var pv=document.querySelectorAll("#bvSec video.bvv"); for(var k=0;k<pv.length;k++) pv[k].pause();
    ov.classList.add("on"); document.body.style.overflow="hidden";
  }
  function load(){
    var vids=window._bvVids||[]; var v=vids[curIdx]||{};
    if(bar) bar.style.width="0%";
    ovVideo.src=v.video||""; if(v.poster) ovVideo.poster=v.poster;
    ovVideo.muted=muted; ovVideo.currentTime=0;
    if(counter) counter.textContent=(curIdx+1)+" / "+vids.length;
    // didascalia recensione (come l'esempio): stelle verdi + nome·luogo + testo. Solo se il video ha i dati.
    if(caption){
      var nm=(v.name||"").trim(), pl=(v.place||"").trim(), tx=(v.text||v.review||"").trim(), st=Math.max(1,Math.min(5,+v.stars||5));
      if(nm||tx){
        if(capStars){ var sh=""; for(var _s=0;_s<st;_s++) sh+='<i>'+ICON_STAR+'</i>'; capStars.innerHTML=sh; }
        if(capName) capName.textContent = nm + (pl?(" · "+pl):"");
        if(capText) capText.textContent = tx;
        caption.style.display="";
      } else { caption.style.display="none"; }
    }
    var pr=ovVideo.play&&ovVideo.play(); if(pr&&pr.catch)pr.catch(function(){});
  }
  function step(d){ var n=(window._bvVids||[]).length; if(!n)return; curIdx=(curIdx+d+n)%n; load(); }
  function closeFull(){ if(!ov)return; try{ovVideo.pause(); ovVideo.removeAttribute("src"); ovVideo.load&&ovVideo.load();}catch(e){}
    ov.classList.remove("on"); document.body.style.overflow="";
    var pv=document.querySelectorAll("#bvSec video.bvv"); for(var k=0;k<pv.length;k++){ try{pv[k].play&&pv[k].play().catch(function(){});}catch(e){} } }

  function injectCSS(){ if(document.getElementById("bvStyles")) return;
    var s=document.createElement("style"); s.id="bvStyles";
    s.textContent=""
     /* SECTION — pulita, in TEMA. Header centrato; reel puliti SENZA sfondo/tinta colorata */
     /* --bva/--bva2 = colori della sezione: default = TEMA della pagina, sovrascrivibili dall'editor */
     +".bvsec{--bva:var(--accent,#9a5a34);--bva2:var(--accent2,#7c4526);padding:clamp(38px,6vw,72px) 0;background:var(--bg2,#faf7f2)}"
     +".bvsec .wrapx{overflow:visible}.bvinner{max-width:var(--maxw,1320px);margin:0 auto}"
     +".bvhead{text-align:center;max-width:660px;margin:0 auto clamp(22px,3vw,36px);display:flex;flex-direction:column;align-items:center;gap:11px}"
     +".bveyb{display:inline-flex;align-items:center;gap:9px;font-size:11px;font-weight:800;letter-spacing:2.6px;text-transform:uppercase;color:var(--bva2)}"
     +".bvdot{width:7px;height:7px;border-radius:50%;background:var(--bva);animation:bvpulse 2s infinite}"
     +"@keyframes bvpulse{0%{box-shadow:0 0 0 0 color-mix(in srgb,var(--bva) 55%,transparent)}70%{box-shadow:0 0 0 8px transparent}100%{box-shadow:0 0 0 0 transparent}}"
     +".bvtitle{margin:0;font-family:var(--disp,inherit);font-weight:700;letter-spacing:-.02em;line-height:1.02;font-size:clamp(25px,4.4vw,42px);color:var(--ink,#1c1a18)}"
     +".bvsub{margin:0;font-size:clamp(14px,1.5vw,16.5px);line-height:1.5;color:var(--ink2,#5b544c);max-width:46ch}"
     +".bvline{width:0;height:3px;border-radius:3px;background:linear-gradient(90deg,var(--bva),var(--bva2));transition:width .85s cubic-bezier(.2,.7,.2,1) .25s;margin-top:5px}"
     +".bvsec.in .bvline{width:56px}"
     +".bvviewport{position:relative;min-width:0}"
     /* strip: centrata quando i video ci stanno; scroll (drag+snap) quando eccedono; sfumatura ai bordi solo se scrollabile */
     +".bvstrip{display:flex;gap:clamp(13px,1.5vw,20px);width:max-content;max-width:100%;margin-inline:auto;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;padding:12px 6px 20px;scrollbar-width:none}.bvstrip::-webkit-scrollbar{display:none}"
     +".bvstrip.grab{cursor:grabbing;scroll-behavior:auto;scroll-snap-type:none}"
     +".bvstrip.one .bvc{width:min(250px,76vw)}"
     /* CARD minimal: bordo SOTTILE appena accennato (in tema), video pulito, ombra soft. Niente anello marcato ne maschera ai lati */
     +".bvc{position:relative;flex:0 0 auto;width:clamp(128px,31vw,166px);aspect-ratio:9/16;padding:0;border:1px solid color-mix(in srgb,var(--bva) 20%,var(--line,#ece6de));border-radius:16px;overflow:hidden;cursor:pointer;scroll-snap-align:center;background:#0c0c10;opacity:0;transform:translateY(24px) scale(.965);transition:opacity .6s ease,transform .6s cubic-bezier(.2,.7,.2,1),border-color .3s}"
     +".bvsec.in .bvc{opacity:1;transform:none}"
     +".bvmedia{position:relative;display:block;width:100%;height:100%;overflow:hidden}"
     +".bvv{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;transition:transform .6s cubic-bezier(.2,.7,.2,1)}"
     +".bvgrad{position:absolute;inset:0;background:linear-gradient(to top,rgba(0,0,0,.2),rgba(0,0,0,0) 32%);pointer-events:none}"
     +".bvplay{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:48px;height:48px;border-radius:50%;background:rgba(18,18,22,.4);display:flex;align-items:center;justify-content:center;pointer-events:none;backdrop-filter:blur(6px);transition:transform .3s,background .3s}"
     +".bvplay svg{width:18px;height:18px;fill:#fff;margin-left:3px}"
     +".bvmini{position:absolute;right:8px;bottom:8px;width:24px;height:24px;border-radius:50%;background:rgba(12,12,16,.48);display:flex;align-items:center;justify-content:center;pointer-events:none;backdrop-filter:blur(2px)}.bvmini svg{width:13px;height:13px;fill:#fff}"
     +"@media(hover:hover){.bvc:hover{transform:translateY(-6px);border-color:var(--bva)}.bvc:hover .bvv{transform:scale(1.06)}.bvc:hover .bvplay{transform:translate(-50%,-50%) scale(1.1);background:rgba(18,18,22,.6)}}"
     /* card più grandi su desktop; frecce SOLO quando scrollabile (tanti video) */
     +".bvarr{display:none}"
     +"@media(min-width:900px){.bvc{width:clamp(210px,18vw,252px);border-radius:18px}"
       +".bvviewport.bvscroll .bvarr{display:flex;position:absolute;top:calc(50% - 4px);transform:translateY(-50%);width:46px;height:46px;border-radius:50%;background:var(--bg,#fff);border:1px solid var(--line,#ece6de);box-shadow:var(--shadow,0 8px 30px rgba(28,22,16,.14));cursor:pointer;align-items:center;justify-content:center;z-index:3;transition:background .15s,transform .15s,opacity .2s}"
       +".bvarr:hover{background:var(--bg2,#faf7f2);transform:translateY(-50%) scale(1.08)}.bvarr.prev{left:-8px}.bvarr.next{right:-8px}"
       +".bvarr svg{width:22px;height:22px;fill:none;stroke:var(--ink,#1c1a18);stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.bvarr:disabled{opacity:0!important;pointer-events:none}}"
     /* PLAYER */
     +".bvov{position:fixed;inset:0;z-index:10000;background:rgba(6,6,9,.9);backdrop-filter:blur(9px);display:flex;align-items:center;justify-content:center;gap:16px;opacity:0;visibility:hidden;transition:opacity .28s}.bvov.on{opacity:1;visibility:visible}"
     +".bvstage{position:relative;height:min(86vh,760px);aspect-ratio:9/16;max-width:94vw;border-radius:18px;overflow:hidden;background:#000;box-shadow:0 30px 80px rgba(0,0,0,.55);transform:scale(.93);transition:transform .34s cubic-bezier(.2,.7,.2,1)}.bvov.on .bvstage{transform:none}"
     +".bvfull{width:100%;height:100%;object-fit:cover;display:block;background:#000}"
     +".bvtapzone{position:absolute;inset:0;z-index:1;cursor:pointer}"
     +".bvbig{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(.6);width:80px;height:80px;border-radius:50%;background:rgba(12,12,16,.5);display:flex;align-items:center;justify-content:center;opacity:0;pointer-events:none;z-index:2;transition:opacity .32s,transform .32s;backdrop-filter:blur(3px)}.bvbig.show{opacity:1;transform:translate(-50%,-50%) scale(1)}.bvbig svg{width:36px;height:36px;fill:#fff}"
     +".bvtop{position:absolute;top:12px;left:12px;right:12px;display:flex;align-items:center;gap:10px;z-index:3}"
     +".bvmute{width:40px;height:40px;border-radius:50%;border:0;background:rgba(12,12,16,.42);cursor:pointer;display:flex;align-items:center;justify-content:center;backdrop-filter:blur(3px)}.bvmute svg{width:20px;height:20px;fill:#fff}"
     +".bvcount{margin-left:auto;font-size:12px;font-weight:800;color:#fff;background:rgba(12,12,16,.42);padding:5px 12px;border-radius:20px;letter-spacing:.6px;font-variant-numeric:tabular-nums;backdrop-filter:blur(3px)}"
     /* didascalia recensione (stelle verdi + nome·luogo + testo) come esempio */
     +".bvcap{position:absolute;left:0;right:0;bottom:0;z-index:2;padding:54px 20px 30px;color:#fff;pointer-events:none;background:linear-gradient(to top,rgba(0,0,0,.85),rgba(0,0,0,.55) 42%,transparent)}"
     +".bvstars{display:flex;gap:3px;margin-bottom:10px}.bvstars i{width:20px;height:20px;border-radius:4px;background:#00b67a;display:flex;align-items:center;justify-content:center}.bvstars i svg{width:12px;height:12px;fill:#fff}"
     +".bvcapn{display:block;font-weight:800;font-size:17px;letter-spacing:-.01em;margin-bottom:5px}"
     +".bvcapt{font-size:14.5px;line-height:1.45;color:rgba(255,255,255,.9);display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}"
     +".bvprog{position:absolute;left:14px;right:14px;bottom:12px;height:4px;border-radius:4px;background:rgba(255,255,255,.28);z-index:3;cursor:pointer}.bvbar{display:block;height:100%;width:0;border-radius:4px;background:#fff;transition:width .12s linear}"
     +".bvx{position:absolute;top:16px;right:18px;width:44px;height:44px;border-radius:50%;border:0;background:rgba(255,255,255,.14);color:#fff;font-size:27px;line-height:1;cursor:pointer;z-index:5}.bvx:hover{background:rgba(255,255,255,.24)}"
     +".bvnav{flex:0 0 auto;width:48px;height:48px;border-radius:50%;border:0;background:rgba(255,255,255,.13);cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:4}.bvnav:hover{background:rgba(255,255,255,.24)}.bvnav svg{width:24px;height:24px;fill:none;stroke:#fff;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round}"
     +"@media(max-width:640px){.bvnav{position:absolute;top:50%;transform:translateY(-50%);width:42px;height:42px;background:rgba(255,255,255,.14)}.bvnav.prev{left:12px}.bvnav.next{right:12px}.bvstage{height:100%;max-width:100vw;border-radius:0}.bvov{gap:0}.bvprog{bottom:16px}}"
     +"@media(prefers-reduced-motion:reduce){.bvov,.bvstage,.bvc,.bvv,.bvbig,.bvplay,.bvline{transition:none}.bvdot,.bvring{animation:none}}";
    document.head.appendChild(s);
  }

  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

/* ============ SOCIAL PROOF TOAST ============ */
(function(){
  var el=document.getElementById("toast"); if(!el) return;
  // FIX (v265): il toast NASCOSTO ha opacity:0 ma restava CLICCABILE (niente pointer-events:none) e,
  // traslato in basso, su mobile copriva la barra sticky (z-index 70 > 60) → INTERCETTAVA i tap sul
  // bottone "Choose my pack" (cliccabile solo quando il toast era .show e saliva). Ora quando non è
  // .show non riceve puntatore. Iniettato da JS → arriva alle pagine esistenti con l'upgrade-js.
  if(!document.getElementById("toastFix")){ var _tf=document.createElement("style"); _tf.id="toastFix";
    _tf.textContent=".toast:not(.show){pointer-events:none}"; document.head.appendChild(_tf); }
  var data=window.LP_TOAST; if(!data||!data.length||typeof data.map!=="function") return;   // inyectado por Liquid (lp-toast): [{n,t,a,img}]
  var i=0;
  function show(){
    var d=data[i%data.length]; i++;
    var im=document.getElementById("toastImg"); if(im&&d.img) im.src=d.img;
    var nm=document.getElementById("toastName"); if(nm) nm.textContent=d.n||"";
    var tt=document.getElementById("toastTxt"); if(tt) tt.textContent=" "+(d.t||"");
    var ag=document.getElementById("toastAgo"); if(ag) ag.textContent=d.a||"";
    el.classList.add("show");
    setTimeout(function(){ el.classList.remove("show"); }, 4500);
  }
  setTimeout(function(){ show(); setInterval(show, 9000); }, 3500);
})();

/* ============ COUNT-UP ============ */
(function(){
  var els=document.querySelectorAll("[data-count]"); if(!els.length) return;
  function run(el){
    var to=parseFloat(el.getAttribute("data-count")), dur=1200, t0=null;
    function step(ts){ if(!t0)t0=ts; var p=Math.min(1,(ts-t0)/dur);
      var v=Math.floor(to*(1-Math.pow(1-p,3)));
      el.textContent=v.toLocaleString(); if(p<1)requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  if(!("IntersectionObserver" in window)){ els.forEach(run); return; }
  var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){run(e.target);io.unobserve(e.target);}});},{threshold:.5});
  els.forEach(function(e){io.observe(e);});
})();

/* ============ GALLERY (carosello scroll-snap: swipe mobile, scroll contenuto) ============ */
var GAL_I = 0;
function galCount(){ return document.querySelectorAll("#galTrack .galslide").length; }
function galShow(i){
  var track=document.getElementById("galTrack"); if(!track) return;
  var n=galCount(); GAL_I=Math.max(0, Math.min(n-1, i));
  track.scrollTo({left: GAL_I*track.clientWidth, behavior:"smooth"});
  galSync();
}
function galSync(){
  var track=document.getElementById("galTrack"); if(!track) return;
  var n=galCount(); if(!n) return;
  GAL_I=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));
  var thumbs=document.querySelectorAll("#galThumbs img");
  thumbs.forEach(function(x,k){ x.classList.toggle("on", k===GAL_I); });
  // centra la thumb attiva scorrendo SOLO il contenitore thumbs (mai la pagina) -> niente salti verticali
  var tw=document.getElementById("galThumbs"), on=thumbs[GAL_I];
  if(tw && on){ tw.scrollLeft = on.offsetLeft - (tw.clientWidth - on.clientWidth)/2; }
  var pv=document.querySelector(".galnav.prev"), nx=document.querySelector(".galnav.next");
  if(pv) pv.style.display = GAL_I<=0 ? "none" : "";
  if(nx) nx.style.display = GAL_I>=n-1 ? "none" : "";
}
function galArrow(d){ galShow(GAL_I+d); }
// porta la gallery principale sull'immagine del colore scelto (se presente tra gli slide)
function galShowColor(color){
  var url=colorImg(color); if(!url) return;
  // v60q: match robusto — protocollo (// vs https:), query, suffissi dimensione Shopify (_800x)
  var nu=function(u){ return String(u||"").split("?")[0].replace(/^https?:/,"").replace(/_\d+x\d*(?=\.\w+$)/,""); };
  var want=nu(url);
  var imgs=document.querySelectorAll("#galTrack .galslide img");
  for(var i=0;i<imgs.length;i++){
    if(nu(imgs[i].getAttribute("src"))===want){ galShow(i); return; }
  }
}
function bmenuToggle(){ var h=document.querySelector(".bhead"); if(h) h.classList.toggle("open"); }
function bmenuClose(){ var h=document.querySelector(".bhead"); if(h) h.classList.remove("open"); }
(function(){
  var track=document.getElementById("galTrack"); if(!track) return;
  var to; track.addEventListener("scroll", function(){ clearTimeout(to); to=setTimeout(galSync,60); }, {passive:true});
  var t=document.getElementById("galThumbs");
  if(t) t.addEventListener("click", function(e){ var img=e.target.closest("img"); if(!img) return; galShow(+img.getAttribute("data-i")); });
  window.addEventListener("resize", function(){ galShow(GAL_I); }, {passive:true});
  galSync();
})();

/* ============ Nascondi il titolo pagina del tema (sopra il banner) ============ */
(function(){
  var pgx=document.querySelector(".pgx"); if(!pgx) return;
  function hideTitles(){
    document.querySelectorAll("h1").forEach(function(h){
      if(pgx.contains(h)) return;
      if(h.compareDocumentPosition(pgx) & Node.DOCUMENT_POSITION_FOLLOWING){
        var w=h.closest(".shopify-section, section, .page-width, .main-page-title, header.page-header");
        if(w && !w.contains(pgx)){ w.style.display="none"; } else { h.style.display="none"; }
      }
    });
  }
  function zeroAncestors(){
    // azzera lo spazio superiore introdotto dai wrapper del tema + nascondi spacer vuoti sopra
    var node=pgx.parentNode;
    while(node && node!==document.body){
      try{ node.style.paddingTop="0"; node.style.paddingBlockStart="0"; node.style.marginTop="0"; node.style.marginBlockStart="0";
           node.style.paddingBottom="0"; node.style.paddingBlockEnd="0"; node.style.marginBottom="0"; node.style.marginBlockEnd="0"; }catch(e){}
      var sib=node.previousElementSibling;
      while(sib){
        var txt=(sib.textContent||"").trim();
        if(!txt && sib.offsetHeight>0 && sib.offsetHeight<160){ sib.style.display="none"; }
        sib=sib.previousElementSibling;
      }
      // spacer vuoti anche SOTTO (gap tra la nostra pagina e il footer del tema)
      var nx=node.nextElementSibling;
      while(nx){
        var tx2=(nx.textContent||"").trim();
        if(!tx2 && nx.offsetHeight>0 && nx.offsetHeight<160){ nx.style.display="none"; }
        nx=nx.nextElementSibling;
      }
      node=node.parentNode;
    }
  }
  // compensa qualsiasi gap residuo (padding di sezione del tema) tirando su la pagina.
  // usa l'offset ASSOLUTO nel documento (top + scrollY) => stabile anche se si scrolla mentre carica.
  function pull(){ try{
    pgx.style.marginTop="0";
    var sy=(window.pageYOffset||document.documentElement.scrollTop||0);
    var docTop=pgx.getBoundingClientRect().top+sy;
    if(docTop>1 && docTop<420){ pgx.style.marginTop=(-docTop)+"px"; }
  }catch(e){} }
  function fix(){ hideTitles(); zeroAncestors(); pull(); }
  fix(); requestAnimationFrame(fix);
  [60,200,500,1000,2000].forEach(function(ms){ setTimeout(fix,ms); });
  window.addEventListener("load", fix);
  // il tema a volte inietta il titolo dopo il nostro script: osserva per ~3s
  try{
    var mo=new MutationObserver(function(){ fix(); });
    mo.observe(document.body,{childList:true,subtree:true});
    setTimeout(function(){ mo.disconnect(); },3000);
  }catch(e){}
})();

/* ============ STORIES (lightbox foto/video recensioni) ============ */
var STORY_ELS=[], STORY_I=0;
/* STORY OVERLAY v2: il testo lungo non copre più la foto né viene tagliato — scorre da solo
   verso l'alto in loop, sfumando in cima (pausa con dito/mouse sopra). Stili INIETTATI dal
   bundle così l'auto-upgrade li porta su tutte le pagine esistenti (il CSS baked non si tocca). */
(function(){ if(document.getElementById("stvStyle")) return;
  var st=document.createElement("style"); st.id="stvStyle";
  st.textContent=
    ".storycap{background:linear-gradient(0deg,rgba(0,0,0,.9) 0%,rgba(0,0,0,.5) 58%,transparent 100%)!important;padding:26px 18px 14px!important}"
   +"#storyText{position:relative;margin:6px 0 0;font-size:13.5px;line-height:1.62;color:rgba(255,255,255,.95);max-height:7.4em;overflow:hidden}"
   +"#storyText.stroll{-webkit-mask-image:linear-gradient(180deg,transparent 0,#000 24%,#000 100%);mask-image:linear-gradient(180deg,transparent 0,#000 24%,#000 100%)}"
   +"#storyText .stseg{display:block;padding-bottom:1.35em}"
   +"#storyText.stroll .stseg{animation:stvup var(--stdur,22s) linear infinite}"
   +".storycap:hover .stseg,.storycap:active .stseg{animation-play-state:paused}"
   +"@keyframes stvup{from{transform:translateY(0)}to{transform:translateY(-100%)}}";
  document.head.appendChild(st);
})();
function storyRender(){
  if(!STORY_ELS.length) return;
  STORY_I=(STORY_I%STORY_ELS.length+STORY_ELS.length)%STORY_ELS.length;
  var el=STORY_ELS[STORY_I], img=el.getAttribute("data-img"), vid=el.getAttribute("data-video");
  var m=document.getElementById("storyMedia"); if(!m) return;
  m.innerHTML = vid ? ('<video src="'+vid+'" autoplay muted loop playsinline controls></video>')
                    : ('<img src="'+img+'" alt="">');
  var nm=document.getElementById("storyName"); if(nm) nm.textContent=el.getAttribute("data-name")||"";
  var tx=document.getElementById("storyText");
  if(tx){
    var t=el.getAttribute("data-text")||"";
    tx.classList.remove("stroll"); tx.innerHTML="";
    var s1=document.createElement("span"); s1.className="stseg"; s1.textContent=t; tx.appendChild(s1);
    /* se il testo sfora il riquadro: duplica il blocco e fai il loop continuo (velocità ~13px/s,
       proporzionale alla lunghezza). Testi corti: statici, niente maschera. */
    requestAnimationFrame(function(){
      if(s1.offsetHeight>tx.clientHeight+6){
        var s2=document.createElement("span"); s2.className="stseg"; s2.textContent=t; tx.appendChild(s2);
        tx.style.setProperty("--stdur", Math.max(16, Math.round(s1.offsetHeight/13))+"s");
        tx.classList.add("stroll");
      }
    });
  }
  document.querySelectorAll(".story").forEach(function(x){x.classList.remove("seen");}); el.classList.add("seen");
}
function storyOpen(btn){
  STORY_ELS=Array.prototype.slice.call(btn.parentNode.querySelectorAll(".story"));
  STORY_I=STORY_ELS.indexOf(btn);
  var mo=document.getElementById("storyModal"), ov=document.getElementById("storyOv");
  if(mo)mo.classList.add("open"); if(ov)ov.classList.add("open"); document.body.style.overflow="hidden"; storyRender();
}
function storyClose(){ var mo=document.getElementById("storyModal"), ov=document.getElementById("storyOv");
  if(mo)mo.classList.remove("open"); if(ov)ov.classList.remove("open"); document.body.style.overflow="";
  var m=document.getElementById("storyMedia"); if(m)m.innerHTML=""; }
function storyStep(d){ STORY_I+=d; storyRender(); }

/* ============ FAQ ============ */
document.querySelectorAll(".qa .q").forEach(function(q){
  q.addEventListener("click", function(){
    var qa=q.parentNode, a=qa.querySelector(".a"), open=qa.classList.contains("open");
    document.querySelectorAll(".qa").forEach(function(x){ x.classList.remove("open"); x.querySelector(".a").style.maxHeight=null; });
    if(!open){ qa.classList.add("open"); a.style.maxHeight=a.scrollHeight+"px"; }
  });
});

/* ============ MARQUEE ============ */
(function(){ var t=document.getElementById("mqTrack"); if(t) t.innerHTML += t.innerHTML; })();

/* ============ VIEWERS fluctuation ============ */
(function(){ var el=document.getElementById("vwN"); if(!el) return;
  var n=parseInt(el.textContent,10)||27;
  setInterval(function(){ n+=Math.floor(Math.random()*7)-3; if(n<11)n=11; if(n>58)n=58; el.textContent=n; }, 3500);
})();

/* ============ TIMELINE date dinamiche ============ */
(function(){
  var loc=(PRODUCT&&PRODUCT.locale)||"en-GB", opt={day:"numeric",month:"short"};
  for(var i=0;i<3;i++){ var el=document.getElementById("tlDate"+i); if(!el) continue;
    var d=new Date(); d.setDate(d.getDate()+i); try{el.textContent=d.toLocaleDateString(loc,opt);}catch(e){el.textContent=(d.getDate())+"/"+(d.getMonth()+1);} }
})();
(function(){ var el=document.getElementById("soldN"); if(!el) return; var n=parseInt(el.textContent,10)||34;
  setInterval(function(){ n+=Math.floor(Math.random()*3); if(n>240)n=34; el.textContent=n; }, 8000); })();

/* ============ SCROLL REVEAL ============ */
(function(){
  var els=document.querySelectorAll(".reveal");
  if(!("IntersectionObserver" in window)){ els.forEach(function(e){e.classList.add("in");}); return; }
  var io=new IntersectionObserver(function(ents){ents.forEach(function(en){if(en.isIntersecting){en.target.classList.add("in");io.unobserve(en.target);}});},{threshold:.12});
  els.forEach(function(e){io.observe(e);});
})();

/* ============ EXPOSICION GLOBAL (atributos onclick del HTML / scripts de seccion) ============ */
if(typeof window.lpOpenReleasit!=="function"){
  // fallback: la seccion lp-buy define la version completa (sync de la oferta con el modal Releasit)
  window.lpOpenReleasit=function(){
    var host=document.getElementById("lpReleasitHost"); if(!host) return false;
    var btn=host.querySelector("._rsi-buy-now-button, [id*='releasit_cod_form_button'], button, [role='button']");
    if(!btn) return false;
    try{ btn.click(); }catch(_e){ return false; }
    return true;
  };
}
window.selectRow=selectRow; window.onOpt=onOpt; window.cfSet=cfSet;
window.storyOpen=storyOpen; window.storyClose=storyClose; window.storyStep=storyStep;
window.galArrow=galArrow; window.galShow=galShow; window.galShowColor=galShowColor; window.galSync=galSync;
window.bmenuToggle=bmenuToggle; window.bmenuClose=bmenuClose;
window.cartOpen=cartOpen; window.cartClose=cartClose; window.cartQty=cartQty; window.cartCheckout=cartCheckout; window.cartLoad=cartLoad;
window.scrollBundles=scrollBundles; window.addBundle=addBundle; window.renderBundles=renderBundles; window.updateCTA=updateCTA;
window.readSelectionFromDOM=readSelectionFromDOM;
}
if(document.readyState==="loading") document.addEventListener("DOMContentLoaded", lpBoot); else lpBoot();
})();
